import { createContext, useContext } from "react"

export interface ConfirmationOverlayContextValue {
  id: string
  isDanger: boolean
  isLoading: boolean
  autoFocus: boolean
}

export const ConfirmationOverlayContext =
  createContext<ConfirmationOverlayContextValue | null>(null)

export function useConfirmationOverlayContext() {
  const context = useContext(ConfirmationOverlayContext)
  if (!context) {
    throw new Error(
      "useConfirmationOverlayContext must be used within ConfirmationOverlay.Root"
    )
  }
  return context
}
